import React, { FunctionComponent, useState } from 'react';
import { Box } from '@material-ui/core';
import ICategory from '../../../../../model/ICategory';
import CustomiseCategory from './CustomiseCategory';
import CustomiseOptionsTotal from '../customiseOptions/customiseOptionsTotal/CustomiseOptionsTotal';
import customiseCategoryStyles from './customiseCategoryStyles';
import availableFeaturesService from '../../../../../service/availableFeaturesService';

export interface ICustomiseCategoriesProps {
  categories: ICategory[];
}

const CustomiseCategories: FunctionComponent<ICustomiseCategoriesProps> = ({ categories }) => {
  const [expandedPanelId, setExpanded] = useState<string>('');
  const styles = customiseCategoryStyles();
  const featuresTotalCount = availableFeaturesService.getFeaturesTotalCount(categories);

  return (
    <Box className={styles.accordionContainer}>
      <CustomiseOptionsTotal optionsTotal={featuresTotalCount} />
      {categories?.map((category, value) => (
        <CustomiseCategory
          key={value}
          category={category}
          id={value}
          expandedPanelId={expandedPanelId}
          setExpanded={setExpanded}
        />
      ))}
    </Box>
  );
};

export default CustomiseCategories;
